import { getApiUrlString, setUrlMap } from '../modules/get_apiUrlString'

import { buildPlayerDetailDatas } from './process/modelingPlayerDetailData'
import { createCardBackStrings } from './process/createCardStrings'

import seasonCode from '../json/seasonText.json'
import roundCode from '../json/roundCode.json'
import raceEventCode from '../json/raceEventCode.json'

console.log('api_thread_player.js')
const urlMap = {};

onmessage = async function(ev) {
  Object.assign(urlMap, ev.data);
  setUrlMap(urlMap);

  const queryString = `?player_id=${urlMap.playerId}`;
  const playersListResultPromise = await fetch(getApiUrlString('player', queryString))
    .then(res => res.json())
    .then(res => [res.data.player]);

  // 選手データ成形
  const detailData = buildPlayerDetailDatas(playersListResultPromise)[0];
  const playerBackStrings = await createCardBackStrings([detailData], urlMap.imgOrigin);
  // console.log(playerBackString);

  // 成績データの成形
  // // 成績データ
  const playerGrades = playersListResultPromise[0];
  // // 通算成績
  const gradeTableTotalString = generateGradeTableTotalString(playerGrades);
  // // pist6タイトルのフィルタリングと開催降順ソート
  const holdTitleList = filteredHoldListData(playerGrades.hold_list)
    .map(holdData => {
      // タイトルデータに開催日に関するデータがないため、レースリストから照合
      const applicableRaceInfo = playerGrades.race_result_list.find(raceInfo => {
        return holdData.promoter_year == raceInfo.promoter_year
          && holdData.season == raceInfo.season
          && holdData.round_code == raceInfo.round_code;
      });
      holdData.datetime = (new Date(applicableRaceInfo.first_day)).getTime();
      return holdData;
    })
    .sort((a, b) => b.datetime - a.datetime);
  // // pist6タイトル
  const gradeTableTitleStrings = generateGradeTableTitleString(holdTitleList);
  // // レース戦績
  const gradeTableResultString = generateGradeTableResultString(playerGrades.race_result_list);

  const postData = {
    player: {
      id: detailData.id,
      name_jp: detailData.name_jp,
      name_en: detailData.name_en,
      backStr: playerBackStrings[0].str,
    },
    grade: {
      totalStr: gradeTableTotalString,
      titleStr: gradeTableTitleStrings,
      resultStr: gradeTableResultString
    }
  }

  // console.log(postData);
  postMessage(postData);
}

// 通算成績で使用する、要素テキストの生成
const generateGradeTableTotalString = (detailData) => {
  // htmlに記述されているclass名に対応
  const necessaryKeys = [
    'entry_count', 'first_place_count', 'second_place_count',
    'first_count', 'second_count', 'third_count', 'outside_count',
    'run_count', 'winner_rate', 'second_quinella_rate', 'third_quinella_rate'
  ];
  const unit = (key) => {
    if (/_rate/.test(key)) {
      return '%'
    }
    return '';
  }
  return necessaryKeys.map(key => {
      const txt = detailData[key]
        ? `${detailData[key]}${unit(key)}`
        : 'ー';
      return createGradeTableTdString(txt);
    })
    .join('');
}

// PIST６タイトルで使用するデータのフィルタリング関数
const filteredHoldListData = (holdList) => {
  return holdList.filter(title => title.promoter_year && title.season && title.round_code)
}
// PIST６タイトルで使用する、要素テキストの生成
const generateGradeTableTitleString = (holdList) => {
  if (holdList.length == 0) {
    return null;
  }

  const titleDetailObjs = [
    {
      key: 'promoter_year',
      txt: (year) => `${year}-${year%1000 + 1}`
    },
    {
      key: 'season',
      txt: (season_code) => seasonCode[season_code] ? seasonCode[season_code].ja : 'ー'
    },
    {
      key: 'round_code',
      txt: (round_code) => roundCode[round_code] ? roundCode[round_code].name : 'ー'
    },
    {
      key: 'result',
      txt: (result) => result
    }
  ];

  // PIST６タイトル用columnデータ
  const holdTitleStrings = holdList.map(title => {
    // 表示用固定テキストの設定
    title.result = '優勝';

    // cellデータの生成
    const tdConcatString = titleDetailObjs.map(obj => {
        return createGradeTableTdString(obj.txt(title[obj.key]));
      }).join('');
    return createGradeTableTrString(tdConcatString);
  })
  // 表示用データの分割
  //  [0]: 表示用データ
  //  [1]: アコーディオン用データ
  return (holdTitleStrings.length <= 2
    ? [holdTitleStrings.join('')]
    : [
      holdTitleStrings.slice(0, 2).join(''),
      holdTitleStrings.slice(2).join('')
    ]).filter(str => str)
}

// レース戦績で使用する、要素テキストの生成
const generateGradeTableResultString = (raceResults) => {
  if (raceResults.length == 0) {
    return null;
  }

  const resultDetailObjs = [
    {
      key: 'first_day',
      txt: (dateTxt) => dateTxt ? dateTxt.replace(/-\./g, '/') : 'ー'
    },
    {
      key: 'season',
      txt: (season_code) => seasonCode[season_code] ? seasonCode[season_code].ja : 'ー'
    },
    {
      key: 'round_code',
      txt: (round_code, roundGrade) => roundCode[round_code]
        ? createGradeTableTdString(
            roundCode[round_code].name,
            `/league/player/?year=${roundGrade.promoter_year}&season=${roundGrade.season}&round_code=${roundGrade.round_code}`
          )
        : 'ー'
    },
    {
      key: 'tt_record',
      txt: (ttTime) => ttTime
        ? ttTime.split('.').map((str, sIdx) => sIdx == 0 ? str : str.padEnd(3, '0')).slice(0, 2).join('.')
        : 'ー'
    },
    {
      key: 'tt_rank',
      txt: (ttRank, roundGrade) => ttRank
        ? createGradeTableTdString(
            `${ttRank}位`,
            `/league/timetrial/?year=${roundGrade.promoter_year}&season=${roundGrade.season}&round_code=${roundGrade.round_code}`
          )
        : 'ー'
    },
    {
      key: 'race_list',
      txt: (raceList) => {
        // nullデータ除去のフィルタリング、レースIDの昇順ソート（昇順が開催順と仮定）
        // raceResultListは min:1, max:4個の配列となる
        const raceResultList = raceList.filter(raceInfo => raceInfo.race_id && raceInfo.event_code).sort((a, b) => a.race_id - b.race_id);
        // 1次予選、2次予選、準決勝:順位戦、決勝:順位決定戦の４レース分を生成
        return [...Array(4)].map((_, rIdx) => {
          const raceInfo = raceResultList[rIdx];
          // レースデータに合わせて要素テキストの生成
          return raceInfo
            ? createGradeTableTdString(
                createOrderTxt(raceInfo.event_code, raceInfo.rank),
                createRaceHrefTxt(raceInfo.race_id, raceInfo.rank)
              )
            : createGradeTableTdString('ー');
        }).join('')
      }
    },
  ]

  // 順位テキスト生成関数
  const createOrderTxt = (raceCode, orderNum) => {
    if (/[1-6]/.test(orderNum)) {
      // 予選時以外の際に付与するテキストの生成
      const prefix = (() => {
        if (!raceEventCode[raceCode]) {
          return '';
        }
        if (['u', 'v'].includes(raceCode.toLowerCase())) {
          return ''
        }
        return raceEventCode[raceCode].name;
      })();
      return `${prefix}${orderNum}着`;
    }
    // 欠場・失格時のテキスト
    return orderNum;
  }
  // リンクテキスト生成関数
  const createRaceHrefTxt = (raceId, rankNum) => {
    if (/[1-6]/.test(rankNum)) {
      return `/league/racecard/?race_id=${raceId}`
    }
    return null;
  }

  // レース戦績用columnデータ
  // // nullデータのフィルタリング
  // // レース戦績の降順ソート
  const raceResultStrings = raceResults.filter(result => {
      return Object.values(result).filter(value => {
        return value && (typeof value == 'number' || value.length)
      }).length == Object.keys(result).length
    })
    .map(result => {
      result.datetime = (new Date(result.first_day)).getTime();
      return result;
    })
    .sort((a, b) => b.datetime - a.datetime)
    .map(result => {
      // cellデータの生成
      const tdConcatString = resultDetailObjs.map(obj => {
          return ['round_code', 'tt_rank', 'race_list'].includes(obj.key)
            ? obj.txt(result[obj.key], result)
            : createGradeTableTdString(obj.txt(result[obj.key]));
        })
        .join('');
      return createGradeTableTrString(tdConcatString);
    });
    console.log({raceResultStrings})
  // 表示用データの分割
  //  [0]: 表示用データ
  //  [1]: アコーディオン用データ
  return (raceResultStrings.length <= 2
    ? [raceResultStrings.join('')]
    : [
      raceResultStrings.slice(0, 2).join(''),
      raceResultStrings.slice(2).join('')
    ]).filter(str => str)
}

// td要素String生成関数
const createGradeTableTdString = (txt, href = null) => {
  const para = `<p class="at-grade-table__txt">${txt}</p>`;
  const injectTxt = href
    ? `<a href="${href}" target="_blank">${para}</a>`
    : para;
  return `<div class="at-grade-table__td">${injectTxt}</div>`
}
// tr要素String生成関数
const createGradeTableTrString = (tdString) => {
  return `<div class="at-grade-table__tr">${tdString}</div>`;
}
